module.exports = __webpack_public_path__ + "static/media/jennifer-huett.ed6c1960.jpg";